import { cn } from '@/lib/utils'

/**
 * Right-pointing triangle icon (play/expand). Use with rotate-90 or rotate-180
 * for collapse/expand indicators. transformOrigin is set for correct rotation.
 */
export function PlayFilledIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			width='24'
			height='24'
			fill='currentColor'
			className={cn('origin-center', props.className)}
			aria-hidden
			{...props}>
			<title>Expand</title>
			<path d='M6 4l12 8-12 8z' />
		</svg>
	)
}
